import __request__ from "routing/request";
export function permissions() {
  return __request__("GET", "/system/permissions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function readerPermissions(username) {
  return __request__("GET", `/system/permissions/reader/${username}`, null, {}, {
    "Accept": ["application/json"]
  });
}
